import React from "react";
import { observer } from "mobx-react-lite";

import useThemeService from "../../services/theme-service/ThemeService";
import { Question } from "../svg/svgImageList";
import { UploadInProgressWarning } from "./UploadInProgressWarningModel";
import { Dialog } from "../dialog/Dialog";

interface UploadInProgressWarningProps {
  uploadInProgressWarning: UploadInProgressWarning;
  proceedMethod: () => void;
}

export default observer(function UploadInProgressWarning(props: UploadInProgressWarningProps) {
  const { uploadInProgressWarning: uploadWarning, proceedMethod } = props;
  const { themeClass } = useThemeService();

  const iconQuestion = {
    svg: Question,
    width: 30,
    height: 30,
    className: themeClass(["icon-question"]),
  };

  return (
    <Dialog
      isVisible={uploadWarning.isVisible}
      onHide={uploadWarning.cancel}
      iconTitle={iconQuestion}
      titleKey="general.upload.change-organization-when-upload-in-progress-modal.title"
      subTextKey="general.upload.change-organization-when-upload-in-progress-modal.text"
      buttonOk={{
        textKey: "general.upload.change-organization-when-upload-in-progress-modal.change",
        action: proceedMethod,
      }}
      buttonCancel={{
        textKey: "general.stay",
        action: uploadWarning.cancel,
      }}
    />
  );
});
